import { call, put, takeLatest } from "redux-saga/effects";
import { PettyCashierContactReportAction } from "../../actions";
import * as types from "../../actions/actionTypes";
import * as contactReportApi from "../../api/contactReport/pettyCashierContactReport";
import { GetFilter } from "../../containers/contactReports/filter/tools";
import { SetMessage } from "../../assets/errorMessages";

export function* pettyCashierWatcherContactReport() {
  yield takeLatest(types.PETTY_CASHIER_GET_CONTACT_SUMMARY_REQUEST, worker);
}

async function fetchList(pageNumber = null) {
  const page_number = pageNumber ? pageNumber : "";
  return contactReportApi.getSummaryList(page_number, GetFilter());
}

function* worker(action) {
  try {
    const response = yield call(fetchList, action.pageNumber);
    yield put(PettyCashierContactReportAction.getSummarySuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(PettyCashierContactReportAction.getSummaryFailure(message));
  }
}
